import { isAfter, isBefore } from "date-fns";

export function useTimedComponent(saleStart?: Date, saleEnd?: Date) {
  const currentDate = ref(new Date());

  const isActive = computed(() => {
    if (!saleStart || !saleEnd) return false;
    return (
      isAfter(currentDate.value, saleStart) &&
      isBefore(currentDate.value, saleEnd)
    );
  });

  return {
    isActive,
  };
}
